module.exports = __webpack_public_path__ + "static/img/per.2f6b00b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/per.svg
// module id = Tayt
// module chunks = 0